import {
  BillingApiCurrencyListRequest, BillingApiCurrencyListResponse,
  BillingApiCurrencyUpdateRequest, BillingApiCurrencyUpdateResponse,
  BillingApiTariffRequest, BillingApiTariffResponse,
  BillingApiUpdateTrialEndDateRequest,
  BillingApiUpdateTrialEndDateResponse,
  BillingApiSubscriptionCancelRequest,
  BillingApiSubscriptionCancelResponse,
  BillingApiSubscriptionResumeRequest,
  BillingApiSubscriptionResumeResponse,
  BillingApiSetupIntentRequest,
  BillingApiSetupIntentResponse,
  BillingApiAttachPaymentMethodRequest,
  BillingApiAttachPaymentMethodResponse,
  BillingApiGetInvoiceListRequest,
  BillingApiGetInvoiceListResponse,
  BillingApiDownloadInvoiceRequest,
  BillingApiDownloadInvoiceResponse,
  BillingApiGetPaymentMethodsRequest,
  BillingApiGetPaymentMethodsResponse,
  BillingApiDetachPaymentMethodRequest,
  BillingApiDetachPaymentMethodResponse,
  BillingApiUpdateDefaultPaymentMethodRequest,
  BillingApiUpdateDefaultPaymentMethodResponse,
  BillingApiSubscriptionPricesResponse,
  EmptyRequest,
} from "../../proto/generated/api_entities_pb";
import {API} from "../API";
import {BillingApiServiceClient} from "../../proto/generated/api_entities_grpc_web_pb";
import {getProxyUrl} from "../helpers/getProxyUrl";

const client = new BillingApiServiceClient(getProxyUrl(), null, null);

export class BillingApi {
  static async getCurrencyList(req: BillingApiCurrencyListRequest): Promise<BillingApiCurrencyListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiCurrencyListRequest, BillingApiCurrencyListResponse>(client, client.currencyList, req, resolve, reject)
    })
  }

  static async updateCurrency(req: BillingApiCurrencyUpdateRequest): Promise<BillingApiCurrencyUpdateResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiCurrencyUpdateRequest, BillingApiCurrencyUpdateResponse>(client, client.currencyUpdate, req, resolve, reject)
    })
  }

  static async getTariff(req: BillingApiTariffRequest): Promise<BillingApiTariffResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiTariffRequest, BillingApiTariffResponse>(client, client.getTariff, req, resolve, reject)
    })
  }

  static async updateTrialEndDate(req: BillingApiUpdateTrialEndDateRequest): Promise<BillingApiUpdateTrialEndDateResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiUpdateTrialEndDateRequest, BillingApiUpdateTrialEndDateResponse>(client, client.updateTrialEndDate, req, resolve, reject)
    })
  }

  static async cancelSubscription(req: BillingApiSubscriptionCancelRequest): Promise<BillingApiSubscriptionCancelResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiSubscriptionCancelRequest, BillingApiSubscriptionCancelResponse>(client, client.cancelSubscription, req, resolve, reject)
    })
  }

  static async resumeSubscription(req: BillingApiSubscriptionResumeRequest): Promise<BillingApiSubscriptionResumeResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiSubscriptionResumeRequest, BillingApiSubscriptionResumeResponse>(client, client.resumeSubscription, req, resolve, reject)
    })
  }

  static async createSetupIntent(req: BillingApiSetupIntentRequest): Promise<BillingApiSetupIntentResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiSetupIntentRequest, BillingApiSetupIntentResponse>(client, client.createSetupIntent, req, resolve, reject)
    })
  }

  static async attachPaymentMethod(req: BillingApiAttachPaymentMethodRequest): Promise<BillingApiAttachPaymentMethodResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiAttachPaymentMethodRequest, BillingApiAttachPaymentMethodResponse>(client, client.attachPaymentMethod, req, resolve, reject)
    })
  }

  static async getInvoiceList(req: BillingApiGetInvoiceListRequest): Promise<BillingApiGetInvoiceListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiGetInvoiceListRequest, BillingApiGetInvoiceListResponse>(client, client.getInvoiceList, req, resolve, reject)
    })
  }

  static async getStripeInvoiceList(req: EmptyRequest): Promise<BillingApiGetInvoiceListResponse> {
    return new Promise((resolve, reject) => {
      API.call<EmptyRequest, BillingApiGetInvoiceListResponse>(client, client.getStripeInvoiceList, req, resolve, reject)
    })
  }

  static async downloadInvoice(req: BillingApiDownloadInvoiceRequest): Promise<BillingApiDownloadInvoiceResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiDownloadInvoiceRequest, BillingApiDownloadInvoiceResponse>(client, client.downloadInvoice, req, resolve, reject)
    })
  }

  static async getPaymentMethods(req: BillingApiGetPaymentMethodsRequest): Promise<BillingApiGetPaymentMethodsResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiGetPaymentMethodsRequest, BillingApiGetPaymentMethodsResponse>(client, client.getPaymentMethods, req, resolve, reject)
    })
  }

  static async detachPaymentMethod(req: BillingApiDetachPaymentMethodRequest): Promise<BillingApiDetachPaymentMethodResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiDetachPaymentMethodRequest, BillingApiDetachPaymentMethodResponse>(client, client.detachPaymentMethod, req, resolve, reject)
    })
  }

  static async updateDefaultPaymentMethod(req: BillingApiUpdateDefaultPaymentMethodRequest): Promise<BillingApiUpdateDefaultPaymentMethodResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiUpdateDefaultPaymentMethodRequest, BillingApiUpdateDefaultPaymentMethodResponse>(client, client.updateDefaultPaymentMethod, req, resolve, reject)
    })
  }

  static async getSubscriptionPrices(req: EmptyRequest): Promise<BillingApiSubscriptionPricesResponse> {
    return new Promise((resolve, reject) => {
      API.call<EmptyRequest, BillingApiSubscriptionPricesResponse>(client, client.getSubscriptionPrices, req, resolve, reject)
    })
  }

  static async updateSubscriptionQuantity(req: BillingApiUpdateSubscriptionQuantityRequest): Promise<BillingApiUpdateSubscriptionQuantityResponse> {
    return new Promise((resolve, reject) => {
      API.call<BillingApiUpdateSubscriptionQuantityRequest, BillingApiUpdateSubscriptionQuantityResponse>(client, client.updateSubscriptionQuantity, req, resolve, reject)
    })
  }
}
